package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_03_21_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Caper breaks the bad news about Korvis’s departure to Aloysius, who Korvis awakened with his druid magic on Shimmer 6.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Around midday, Elrovir Rodiridan arrives wearing nice armor, adorned with leaves; a longbow; a bandoleer; and a wide-brimmed hat. He warmly greets the heroes and asks about Gorem's absence. 🤦 Tuesday recounts the dangerous journey on “The Cloud Chaser.” The group thinks that Umbraxus was a shadow dragon but are perplexed because shadow dragons are normally subterranean. Elrovir compliments Caper on her pirate costume.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Elrovir thinks that Neldor, a city in the north, may have a teleportation circle. Elrovir was born and raised in the Gideon Forest but seldom traveled to Neldor.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Elrovir has tracked the Shard of Concar to the western edge of the Gideon Forest, but there are reports of giants and giant-kin (not indigenous). Elrovir killed some lesser fiends. Highridge, a town northwest of Kostigan, was sacked by giants and demons. The heroes agree that they need to travel to Highridge, but first Caper and Falorn need to go to church. At the church, there are many refugees that have fled from Highridge.  The mayor of Highridge’s wife, Lily Gruet, tells the heroes how the demons kidnapped her poor husband, Roneth:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Two-headed creatures")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Some dull & dumb")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("One very large and not as dumb")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("One in charge with fairy wings and whip.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Militia easily defeated")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("One malefactor summoned lightning and thunder.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Mayor Roneth Gruet used to be a ranger in the infantry.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The border guards at the northern wall are swamped with refugees trying to enter as the Friends of the Forest depart Kostigan. Elrovir suggests off-road travel for safety. When the sun begins to set, the heroes ask Dirk if he can summon a Tiny Hut, and he amazes them with a Magnificent Mansion!")
    }
}
